module.exports = __webpack_public_path__ + "static/img/13_1.f3f59fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/13_1.png
// module id = kqd1
// module chunks = 0